import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const GIS_SEARCH_EVENT_NAMES = {
  SELECT_GIS_SEARCH_RESULT: 'select_gis_search_result',
};

export const trackClickOnSuggestedLocation = (
  irpVersion,
  gisSource,
  gisType,
) => {
  gspx.trackEvent({
    name: GIS_SEARCH_EVENT_NAMES.SELECT_GIS_SEARCH_RESULT,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Data Jurisdiction',
      legacy_name: 'Select GIS Search Result',
      Category: 'GIS Search',
      'Launched date': new Date(),
      irpVersion,
      gisSource,
      gisType,
    },
  });
};
